import { render, staticRenderFns } from "./allStatistic.vue?vue&type=template&id=4f0737d8&scoped=true&"
import script from "./allStatistic.vue?vue&type=script&lang=js&"
export * from "./allStatistic.vue?vue&type=script&lang=js&"
import style0 from "./allStatistic.vue?vue&type=style&index=0&id=4f0737d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0737d8",
  null
  
)

export default component.exports